import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=2e5b145e&scoped=true"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=2e5b145e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5b145e",
  null
  
)

export default component.exports